export const defaultTemplatePreviewConfig = {
  artist: null,
  assets: {
    default: {
      _hash: 'a3464900be84ac398fd0e531c7c30cd1',
      '500x680':
        '//g0.evitecdn.com/premium_assets/fabric_gallery_asset/1681920387/4762301120708608_default_500x680.gif',
      '250x340':
        '//g0.evitecdn.com/premium_assets/fabric_gallery_asset/1681920388/4762301120708608_default_250x340.gif',
    },
    birthday_forkids: {
      _hash: '32f9b0f2b44a8ec0793192610a0ae508',
      '500x680':
        '//g0.evitecdn.com/premium_assets/fabric_gallery_asset/1681920388/4762301120708608_birthday_forkids_500x680.gif',
      '250x340':
        '//g0.evitecdn.com/premium_assets/fabric_gallery_asset/1681920388/4762301120708608_birthday_forkids_250x340.gif',
    },
    babys_first: {
      _hash: '49692dca0a74667cd1494db60376b4ca',
      '500x680':
        '//g0.evitecdn.com/premium_assets/fabric_gallery_asset/1681920390/4762301120708608_babys_first_500x680.gif',
      '250x340':
        '//g0.evitecdn.com/premium_assets/fabric_gallery_asset/1681920390/4762301120708608_babys_first_250x340.gif',
    },
    birthday_forteens: {
      _hash: '08774510b5bc84cd81b1ecc522da24bc',
      '500x680':
        '//g0.evitecdn.com/premium_assets/fabric_gallery_asset/1681920392/4762301120708608_birthday_forteens_500x680.gif',
      '250x340':
        '//g0.evitecdn.com/premium_assets/fabric_gallery_asset/1681920392/4762301120708608_birthday_forteens_250x340.gif',
    },
  },
  displayName: 'Big Confetti',
  eventTitleColor: null,
  informationColor: null,
  eventType: 'birthday_forkids',
  keywords: [
    'Birthday',
    'birthday party',
    "kids' birthday",
    "kid's birthday",
    'birthday for kids',
    'gender neutral',
    'teen birthday',
    'birthday for teens',
    '1st birthday',
    'first birthday',
    'big confetti',
    'dots',
    'colorful',
    'classic',
    'Cake and Confetti',
    'Balloons and Confetti',
    'Confetti and Stars',
    'Gender Neutral',
  ],
  altTag: null,
  templateId: 'big-confetti_ani',
  uyo: false,
  categories: [
    'babys_first',
    'kids_and_teens',
    'birthday_forteens',
    'birthday',
    'birthday_forkids',
    'featured',
  ],
  colors: ['blue', 'green', 'pink', 'yellow', 'white'],
  popularity: 0,
  premium: true,
  metaDescription: null,
  invitationTypes: null,
  favorite: false,
  usedAs: 'invitation',
};
